import * as actionTypes from "./actiontypes";
import * as API from "./api";
import { log } from "../../config/utils";
import { startPageLoading, stopPageLoading } from "../page_details/actions";

export const updateClustersState = payload => {
  return {
    type: actionTypes.UPDATE_CLUSTERS_STATE,
    payload
  };
};

export const updateQueryState = payload => {
  return {
    type: actionTypes.UPDATE_QUERY_STATE,
    payload
  }
}

export const getDateFilter = callback => {
  return dispatch => {
    dispatch(startPageLoading("Fetching available dates"));
    API.getDateFilter({}, (error, res) => {
      if (!error && res && res.data && res.data.dateKeys && res.data.dateKeys.length > 0) {
        log("Available dates:", res.data.dateKeys)
        dispatch({
          type: actionTypes.DATE_FILTER_RECEIVED,
          payload: res.data.dateKeys
        });
        dispatch(stopPageLoading());
        if (callback) callback();
      } else {
        dispatch(stopPageLoading());
      }
    });
  };
};

export const getClusterData = payload => {
  return dispatch => {
    dispatch({
      type: actionTypes.CLUSTER_DATA_LOADING
    });
    API.getClusterData(payload, (error, response) => {
      if (!error && response && response.data && response.data.clusterArr) {
        log("Cluster diagram response:", response)
        dispatch({
          type: actionTypes.CLUSTER_DATA_RECEIVED,
          payload: response.data.clusterArr
        });
      } else {
        dispatch({
          type: actionTypes.CLUSTER_DATA_LOAD_ERROR
        });
      }
    });
  };
};

export const fetchTableData = (payload, callback) => {
  return dispatch => {
    dispatch({
      type: actionTypes.TABLE_DATA_LOADING
    });
    API.fetchTableData(payload, (error, response) => {
      if (!error && response && response.data) {
        log("Table data response: ", response.data)
        dispatch({
          type: actionTypes.TABLE_DATA_RECEIVED,
          payload: {
            intent_records: response.data.clusterArr,
            total_intents: response.data.totalCount || 0,
          }
        });
        if (callback) callback();
      } else {
        dispatch({
          type: actionTypes.TABLE_DATA_LOAD_ERROR
        });
      }
    });
  };
};

export const getUtterances = (payload, callback) => {
  return dispatch => {
    dispatch({
      type: actionTypes.UTTERANCES_DATA_LOADING
    });
    API.getUtterances(payload, (error, response) => {
      if (!error && response && response.uterrances) {
        log("Utterance response: ", response);
        dispatch({
          type: actionTypes.UTTERANCES_DATA_RECEIVED,
          payload: response
        });
        if (callback) callback();
      } else {
        dispatch({
          type: actionTypes.UTTERANCES_DATA_LOAD_ERROR
        });
      }
    });
  };
};

export const getWordCloudData = (payload, callback) => dispatch => {
  dispatch(updateQueryState({ word_cloud_data_loading: true, word_cloud_data_load_error: false }))
  API.getWordCloudData(payload, (error, response) => {
    log("get wordcloud data response", response)
    if (!error && response && response.data) {
      const payload = {
        word_cloud: response.data,
        word_cloud_data_loading: false,
        word_cloud_data_load_error: false
      }
      dispatch(updateQueryState(payload))
      if (callback) callback()
    }
    else
      dispatch(updateQueryState({ word_cloud_data_loading: false, word_cloud_data_load_error: true }))
  })
}

export const loadMoreUtterances = payload => {
  return dispatch => {
    API.getUtterances(payload, (error, response) => {
      log("loadMore getUtterances", response);
      if (!error) {
        dispatch({
          type: actionTypes.MORE_UTTERANCES_RECEIVED,
          payload: response
        });
      }
    });
  };
};



// WEBPACK FOOTER //
// ./src/data/redux/query_details/actions.js